<template>
    <div class="social-content social-icons text-center col-xs-12">
        <social-sharing
            :url="fullPath"
            title="Check out my custom build made on LETSBLD by NZXT"
            quote="Check out my custom build made on LETSBLD by NZXT"
            description="Get a Professionally Custom Built Gaming PC Fast! Guaranteed FPS or your Money Back. Ships in 48-Hours with Full Warranty. Backed by NZXT"
            hashtags="letsbld,nzxt"
            twitter-user="nzxt"
            inline-template>
            <div>
                <network network="facebook">
                    <i class="fa fa-facebook-square" title="Share on Facebook" />
                </network>
                <network network="twitter">
                    <i class="fa fa-twitter" title="Share on Twitter" />
                </network>
                <a
                    title="Share by mail"
                    href=""
                    data-dismiss="modal"
                    data-toggle="modal"
                    data-target="#share-mail"
                    style="color: #1F86FF;">
                    <i class="fa fa-envelope" />
                </a>
            </div>
        </social-sharing>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fullPath: window.location.href
        }
    }
}
</script>
